var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgV2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7848 4H3.21525C1.43889 4 0 5.18531 0 6.65035V19.3497C0 20.8147 1.43889 22 3.21525 22H22.7848C24.5611 22 26 20.8147 26 19.3497V6.65035C26 5.18531 24.5611 4 22.7848 4ZM6.52546 19.3182H4.30038V17.514H6.52546V19.3182ZM6.52546 15.7063H4.30038V13.9021H6.52546V15.7063ZM6.52546 12.0944H4.30038V10.2902H6.52546V12.0944ZM6.52546 8.48601H4.30038V6.67832H6.52546V8.48601ZM21.1157 10.6573L19.4061 12.1678L20.9488 17.028L20.0847 17.8427C19.992 17.9301 19.8362 17.9301 19.7435 17.8427L17.4443 13.9021L15.3304 15.8671L15.6679 17.4161L15.1302 17.9231C15.0597 17.9895 14.9448 17.9895 14.8706 17.9231L11.8259 15.049C11.7555 14.9825 11.7555 14.8741 11.8259 14.8042L12.3637 14.2972L13.9769 14.6084L16.0647 12.6049L11.9149 10.451C11.8222 10.3601 11.8222 10.2168 11.9149 10.1259L12.779 9.31119L17.8967 10.7552L19.5099 9.12937C19.9809 8.68531 20.7226 8.66434 21.1676 9.08741C21.6089 9.51399 21.5904 10.2133 21.1157 10.6573Z",
    fill: "#CDA876"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2);
export default __webpack_public_path__ + "static/media/v2.ded1806f6058f5d420882659ba9fb3eb.svg";
export { ForwardRef as ReactComponent };